export default __webpack_public_path__ + "static/teoco-c2768e6879d995f267993e209da21ba9.svg";